export default "__VITE_ASSET__CPQe5mDu__";